
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: "material-doc-release-list",
directives: {
TransferDom
},
components:{
PopupHeader,
Popup
},
data() {
return {
refresh:true,
wrapperHeight: 0,
allLoaded: false,
config: {
title: '物料文档发布',
url: 'api/material-document/page',
fixRules: {},
inputCondition: {
placeholder: '物料编号/名称',
searchCondition: 'key',
rules: [{
field: "material.matCode-material.matName",
option: "LIKE_ANYWHERE"
}]
},
},
searchData: {},
list: [],
popupShow:false,
showData:{},
supplierShow:false,
viewSupList:[],
publishRecordList:[],
publishRecordShow:false,
isSupplier:false
}
},
methods: {
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function () {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},
viewDetail(data){
this.popupShow = true;
this.showData = data;
},
viewSup(){
this.popupShow = false;
this.supplierShow = true;
this.viewSupList = this.showData.materialDocSuppliers;
},

viewPublish(){
this.popupShow = false;
this.publishRecordShow = true;
this.publishRecordList = this.showData.materialDocSuppliers;
},
cancelPopup(){
this.popupShow = false;
},
cancelSupplier(){
this.supplierShow = false;
},
cancelPublish(){
this.publishRecordShow = false;
},
getIsSupplier(){
this.$get('api/person/current').then((res) => {
if(res.userType === '0'){
this.isSupplier = true;
}else{
this.isSupplier = false;
}
})
}
},
mounted() {
this.getIsSupplier();
if(this.$route.query.matId){
this.config = {
title: '物料文档发布',
url: 'api/material-document/page',
fixRules: {
rules:[{
field:'material.id',
option:'IN',
values:[this.$route.query.matId],
}],
fixed:true
}
};
delete this.config.inputCondition;
}
this.init();
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/material-doc-release/material-doc-release-list.vue